import DynamicFormFieldDefinitionListResultModelBase from '../_generated/modelBases/dynamic-form-field-definition-list-result-model-base';

export default class DynamicFormFieldDefinitionListResultModel extends DynamicFormFieldDefinitionListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
